export class Stage2 {
    validate() {
        // $required = [
        //     'first_name',
        //     'last_name',
        //     'phone',
        //     'email',
        // ];
        
        // delegateDetails
        let dds = Alpine.store('status').currentDelegate().delegate_details;
        
        return (
            (typeof dds.first_name !== 'undefined' && dds.first_name.length > 0) &&
            (typeof dds.last_name !== 'undefined' && dds.last_name.length > 0) &&
            (typeof dds.phone !== 'undefined' && dds.phone.length > 0) &&
            (typeof dds.email !== 'undefined' && dds.email.length > 0)
        );
    }
}